var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      { staticClass: "page-content" },
      [
        _c("page-nav-bar", {
          attrs: {
            currentServiceName: "DealPrudence",
            subNavTitle: "Settings",
            menuAccess: true,
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "layoutTop" }),
        _vm._v(" "),
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "settingBetweenList" }),
          _vm._v(" "),
          _c(
            "nav",
            {
              staticClass: "list-block",
              attrs: { "aria-label": "Paramètres de configuration" },
            },
            [
              _c("ul", { attrs: { role: "list" } }, [
                _vm.serviceName === "Payments" || _vm.serviceName === ""
                  ? _c("li", { attrs: { role: "listitem" } }, [
                      _c(
                        "a",
                        {
                          staticClass: "item-link item-content",
                          attrs: {
                            href: "/settings/application/",
                            "aria-label":
                              _vm.$t("settings.applctn_sttngs") +
                              " - " +
                              _vm.$t("accessibility.navigate_to_settings"),
                          },
                        },
                        [
                          _c("div", { staticClass: "item-inner" }, [
                            _c("div", { staticClass: "item-title" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("settings.applctn_sttngs")) +
                                  "\n                "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ])
                  : _vm.serviceName === "Direct Debit"
                  ? _c("li", { attrs: { role: "listitem" } }, [
                      _c(
                        "a",
                        {
                          staticClass: "item-link item-content",
                          attrs: {
                            href: "/settings/directDebit/",
                            "aria-label":
                              _vm.$t("settings.applctn_sttngs") +
                              " - Direct Debit - " +
                              _vm.$t("accessibility.navigate_to_settings"),
                          },
                        },
                        [
                          _c("div", { staticClass: "item-inner" }, [
                            _c("div", { staticClass: "item-title" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("settings.applctn_sttngs")) +
                                  "\n                "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ])
                  : _vm.serviceName === "Direct Payments"
                  ? _c("li", { attrs: { role: "listitem" } }, [
                      _c(
                        "a",
                        {
                          staticClass: "item-link item-content",
                          attrs: {
                            href: "/settings/directPayments/",
                            "aria-label":
                              _vm.$t("settings.applctn_sttngs") +
                              " - Direct Payments - " +
                              _vm.$t("accessibility.navigate_to_settings"),
                          },
                        },
                        [
                          _c("div", { staticClass: "item-inner" }, [
                            _c("div", { staticClass: "item-title" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("settings.applctn_sttngs")) +
                                  "\n                "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("li", { attrs: { role: "listitem" } }, [
                  _c(
                    "a",
                    {
                      staticClass: "item-link item-content",
                      attrs: {
                        href: "/settings/remind/",
                        "aria-label":
                          "Remind Settings - " +
                          _vm.$t("accessibility.navigate_to_settings"),
                      },
                    },
                    [_vm._m(0)]
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "toolbarPageBottomBlank" }),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-inner" }, [
      _c("div", { staticClass: "item-title" }, [_vm._v("Remind Settings")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }